<template>
	<div class="sidebar">
		<router-link v-if="!mobile" class="back" :to="{ name: 'Knowledge' }">
            <svg
                width="16"
                height="13"
                viewBox="0 0 16 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                d="M2 6.1696L1.29145 5.46394L0.588675 6.1696L1.29145 6.87525L2 6.1696ZM15 7.1696C15.5523 7.1696 16 6.72188 16 6.1696C16 5.61731 15.5523 5.1696 15 5.1696V7.1696ZM6.49145 0.242586L1.29145 5.46394L2.70855 6.87525L7.90855 1.6539L6.49145 0.242586ZM1.29145 6.87525L6.49145 12.0966L7.90855 10.6853L2.70855 5.46394L1.29145 6.87525ZM2 7.1696H15V5.1696H2V7.1696Z"
                fill="#4854FE"
                />
            </svg>
            Назад
		</router-link>
		<div v-if="mobile" class="burger cursor-pointer h-4" @click.prevent="toggleMenu()">
			<svg data-v-4e59dcd0="" width="25" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" class="">
				<rect data-v-4e59dcd0="" width="25" height="3" rx="2" fill="#37F"></rect>
				<rect data-v-4e59dcd0="" y="8" width="25" height="3" rx="2" fill="#37F"></rect>
				<rect data-v-4e59dcd0="" y="16" width="25" height="3" rx="2" fill="#37F"></rect>
			</svg>
		</div>
		<div class="human" v-if="metodistHumanData">
		<div class="human_title">Профиль</div>
		<div class="human_container">
			<div class="human_gender">
			<div
				class="human_gender-item mail"
				v-if="metodistHumanData.gender == 1"
			>
				М
			</div>
			<div class="human_gender-item female" v-else>Ж</div>
			</div>
			<div class="human_information">
			<h3 class="human_name">{{ metodistHumanData.name }}</h3>
			<p class="human_age">
				Возраст от {{ metodistHumanData.ageFrom }}
				{{
				metodistHumanData.years == 0
					? "лет"
					: metodistHumanData.years == 1
					? "мес."
					: "дней"
				}}
				до {{ metodistHumanData.ageTo }}
				{{
				metodistHumanData.days == 0
					? "лет"
					: metodistHumanData.days == 1
					? "мес."
					: "дней"
				}}
			</p>
			<!-- <div class="human_stats">
				<div class="status-item">
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M13.6 4.8C12.555 4.8 11.666 4.13215 11.3366 3.2H8V7.2H11.3366C11.666 6.26785 12.555 5.6 13.6 5.6C14.9255 5.6 16 6.67452 16 8C16 9.32548 14.9255 10.4 13.6 10.4C12.555 10.4 11.666 9.73215 11.3366 8.8H8V12.8H11.3366C11.666 11.8678 12.555 11.2 13.6 11.2C14.9255 11.2 16 12.2745 16 13.6C16 14.9255 14.9255 16 13.6 16C12.555 16 11.666 15.3322 11.3366 14.4H7.2C6.75817 14.4 6.4 14.0418 6.4 13.6V8.8H4.66344C4.33397 9.73215 3.44498 10.4 2.4 10.4C1.07452 10.4 0 9.32548 0 8C0 6.67452 1.07452 5.6 2.4 5.6C3.44498 5.6 4.33397 6.26785 4.66344 7.2H6.4V2.4C6.4 1.95817 6.75817 1.6 7.2 1.6H11.3366C11.666 0.667846 12.555 0 13.6 0C14.9255 0 16 1.07452 16 2.4C16 3.72548 14.9255 4.8 13.6 4.8ZM12.8 2.4C12.8 1.95817 13.1582 1.6 13.6 1.6C14.0418 1.6 14.4 1.95817 14.4 2.4C14.4 2.84183 14.0418 3.2 13.6 3.2C13.1582 3.2 12.8 2.84183 12.8 2.4ZM3.2 8C3.2 7.55817 2.84183 7.2 2.4 7.2C1.95817 7.2 1.6 7.55817 1.6 8C1.6 8.44183 1.95817 8.8 2.4 8.8C2.84183 8.8 3.2 8.44183 3.2 8ZM12.8 8C12.8 8.44183 13.1582 8.8 13.6 8.8C14.0418 8.8 14.4 8.44183 14.4 8C14.4 7.55817 14.0418 7.2 13.6 7.2C13.1582 7.2 12.8 7.55817 12.8 8ZM13.6 14.4C13.1582 14.4 12.8 14.0418 12.8 13.6C12.8 13.1582 13.1582 12.8 13.6 12.8C14.0418 12.8 14.4 13.1582 14.4 13.6C14.4 14.0418 14.0418 14.4 13.6 14.4Z" fill="#CACDD3"/>
				</svg>
				<span>10</span>
				</div>
				<div class="status-item">
				<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M6.18182 0C6.39767 0 6.60236 0.0951515 6.74051 0.259715L8.34062 2.16541H13.0909C13.8942 2.16541 14.5454 2.81174 14.5454 3.60901V5.05261H15.2727C15.4906 5.05261 15.697 5.14955 15.8351 5.31679C15.9733 5.48404 16.0286 5.70393 15.9859 5.91596L14.5313 13.134C14.4633 13.4714 14.1649 13.7142 13.8182 13.7142H0.736082C0.714032 13.7145 0.691814 13.7137 0.669482 13.712C0.645802 13.7101 0.622325 13.7071 0.599126 13.703C0.455592 13.6775 0.327726 13.611 0.227362 13.5167C0.210982 13.5013 0.195335 13.4852 0.180471 13.4683C0.0676586 13.3407 6.84913e-06 13.1736 6.84913e-06 12.9924V1.4436C6.84913e-06 0.646323 0.651228 0 1.45455 0H6.18182ZM7.99999 3.60901C7.78414 3.60901 7.57945 3.51388 7.4413 3.34931L5.84119 1.4436H1.45455V7.12915L1.8399 5.59934C1.92084 5.27803 2.21173 5.05261 2.54546 5.05261H13.0909V3.60901H7.99999ZM1.65875 12.2706L3.1133 6.49622H14.3856L13.2219 12.2706H1.65875Z" fill="#CACDD3"/>
				</svg>
				<span>10</span>
				</div>
			</div> -->
			</div>
		</div>
		</div>
		<div class="systems">
		<label for="systems">Системы организма человека</label>
		<v-select
			id="systems"
			hide-details
			outlined
			v-model="system"
			@change="changeSystem()"
			:items="getSystems"
		></v-select>
		</div>
		<!-- <div class="copy_systems">
			<button @click="dialogCopyTree = true" class="redactor_add">Копировать систему</button>
		</div> -->
		<div class="tree">
		<div class="tree_title">Узлы</div>
		<TreeList
			v-if="curentSystem"
			:children="false"
			:tree-data="curentSystem.children"
			:padding="17"
		/>
		</div>
		<v-dialog v-model="dialogCopyProperty" max-width="600" persistent>
		<v-card>
			<v-card-title class="text-h5">
			{{ dialogCopy.text }}
			</v-card-title>
		</v-card>
		</v-dialog>
		<v-dialog v-model="dialogCopyTree" max-width="500" persistent>
		<v-card>
			<v-card-title class="text-h5"> Выбор пациента </v-card-title>
			<v-card-text>
			<div class="form">
				<v-autocomplete
                    :items="getSearchHumans"
                    v-model="humanid"
                    auto-select-first
                    chips
                    label="Выберите человека"
                    @change="getSystemsHumanUpdate()"
                    clearable
                    deletable-chips
                    small-chips
				></v-autocomplete>
				<v-autocomplete
                    v-if="systemsCopy"
                    label="Выберите систему для копирования"
                    :items="systemsCopy"
                    v-model="copyTreeQuery.sourceId"
                    auto-select-first
                    chips
                    clearable
                    deletable-chips
                    small-chips
				></v-autocomplete>
				<v-checkbox
                    v-model="copyTreeQuery.withProperties"
                    label="Копировать свойства?"
				></v-checkbox>
			</div>
			</v-card-text>
			<v-card-actions>
			<v-btn color="green darken-1" text @click="dialogCopyTree = false">
				Отменить
			</v-btn>
			<v-btn
				color="green darken-1"
				text
				@click="
				() => {
					setCopyNode();
				}
				"
			>
				Копировать
			</v-btn>
			</v-card-actions>
		</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { VueTreeList, Tree, TreeNode } from "vue-tree-list";
import _ from "lodash";
import "./MetodistSideBar.scss";
import TreeList from "@/components/Tree/Tree.vue";
export default {
	name: "MetodistSideBar",
	components: { TreeList },
	props: {
      mobile: Boolean
    },
	computed: {
		...mapGetters({
            getSearchHumans: "tree/getSearchHumans",
            getImageUrl: "tree/getImageUrl",
            systemsCopy: "tree/systemsCopy",
            humanData: "tree/humanData",
            curentTree: "tree/curentTree",
            treeData: "tree/treeData",
            curentSystem: "tree/curentSystem",
            getSystems: "tree/getSystems",
            metodistHumanData: "tree/metodistHumanData",
		}),
	},
	watch: {
		system(system) {
			localStorage.system = system;
		}
	},
	data() {
		return {
		add: "",
		system: 0,
		node: "",
		query: {},
		disabled: false,
		treeKey: 0,
		copyTreeQuery: {
			newParentid: null,
			sourceId: null,
			withProperties: false,
			withMediaFiles: false,
			withContent: false,
			newHumanid: null,
		},
		dialogCopy: {
			text: "",
		},
		copy: false,
		humanid: 0,
		copySucces: false,
		dialogCopyTree: false,
		dialogCopyProperty: false,
		};
	},
	methods: {
		...mapActions({
            getTree: "tree/getTree",
            getNode: "tree/getNode",
            getTreeView: "tree/getTreeView",
            setSystem: "tree/setSystem",
            getFiles: "media/getFiles",
            copyNode: "tree/copyNode",
            searchHuman: "tree/searchHuman",
            getHumanById: "tree/getHumanById",
            getUpdateNewSystem: "tree/getUpdateNewSystem",
		}),
		...mapMutations({
            setCurentSystem: "tree/setCurentSystem",
            setKey: "tree/setKey",
            falseActive: "tree/falseActive",
            setNode: "tree/setNode",
            changeCurrentSystemId: "tree/changeCurrentSystemId",
            changeFlagConstructor: "tree/changeFlagConstructor",
            changeFlagConstructorProperty: "property/changeFlagConstructor"
		}),

		getSystemsHumanUpdate() {
		    this.getUpdateNewSystem(this.humanid);
		},
		setCopyNode() {
            this.copyTreeQuery.withMediaFiles = this.copyTreeQuery.withProperties;
            this.copyTreeQuery.withContent = this.copyTreeQuery.withProperties;
            this.copyTreeQuery.newParentid = this.metodistHumanData.bodyTreeItemId;
            this.copyTreeQuery.newHumanid = this.metodistHumanData.id;
            this.dialogCopyTree = false;
            this.dialogCopyProperty = true;
            this.dialogCopy.text = "Система копируется";
            this.copyNode(this.copyTreeQuery).then(() => {
                this.copySucces = true;
                this.changeSystem();
                setTimeout(() => {
                this.dialogCopyProperty = true;
                this.dialogCopy.text = "Система скопирована";
                this.copyTreeQuery.sourceId = null;
                this.dialogCopyProperty = false;
                this.humanid = "";
                this.copyTreeQuery.withProperties = false;
                this.copyTreeQuery.withMediaFiles = false;
                this.copyTreeQuery.withContent = false;
                this.copySucces = false;
                }, 1000);
            });
		},
		changeSystem() {
            this.changeFlagConstructor({ name: 'loadingCurrentSystemId', value: true });
            // this.changeFlagConstructorProperty({ name: 'property', value: [] });

			this.getTreeView(this.$route.params.id)
                .then(() => {
                    this.setCurentSystem(this.system);
                    this.getNode({ id: this.curentSystem.children[0].id, media: true })
                        .then(() => {
                            this.changeFlagConstructor({ name: 'loadingCurrentSystemId', value: false });
                        })
                    this.falseActive(this.curentSystem.children[0]);

                    this.changeCurrentSystemId(this.curentSystem.children[0].id)
                });
		},
		toggleMenu() {
        	this.$emit('toggleMenu');
     	}
	},
	mounted() {
		this.searchHuman({});
		if (localStorage.system) {
			this.system = +localStorage.system;

			if (this.system >= this.getSystems.length) {
				this.system = 0;
			}
		}
		this.getHumanById(this.$route.params.id);
		this.changeSystem();
		this.getFiles();
	},
};
</script>
